import React from 'react';
import { Layout } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import Headline from '../../components/Headline';
import GuideNav from '../../components/navigation/GuideNav';

import '../../styles/Guide.css';

const { Content } = Layout;

const causeData = [
    {
        title : {
            id: 'UnapprovedCause.A.title',
            text : 'Non-compliance with the content guidelines below'
        },
        causes : [
            {
                id: 'UnapprovedCause.A.causes.1',
                text : 'If there is no margin for the sticker (20 px), approval will not be granted.',
            },
            {
                id: 'UnapprovedCause.A.causes.2',
                text : 'If the sticker is too small for the standard, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.3',
                text : 'If the side of the sticker is not filled with color, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.4',
                text : 'If a sticker does not require a background, but is not transparent, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.5',
                text : 'If the quality of the sticker is too poor, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.6',
                text : 'If the GIF loop is not set repeatedly, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.7',
                text : 'If GIF loop is unnatural, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.8',
                text : 'If it has been determined that the visibility of the mobile environment is not sufficient, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.9',
                text : 'If there is a spelling error within the sticker, the sticker will not be approved.',
            },
            {
                id: 'UnapprovedCause.A.causes.10',
                text: 'If you upload a sticker in a different format from the type of sticker you chose, it will not be approved.',
            },
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.B.title',
            text : 'Non-compliance with the tag and language selection guide',
        },
        subtitlePrefix: 'B',
        subtitle: [
            {
                id: 'UnapprovedCause.B.subtitle.1',
                text: 'Non-compliance with the tag guide',
                causes: [
                    {
                        id: 'UnapprovedCause.B.subtitle.1.cause.1',
                        text: 'If the selected tag does not match the emotions and situations shown by the<br> sticker, it is not approved.',
                    }
                ],
            },
            {
                id: 'UnapprovedCause.B.subtitle.2',
                text: 'If the language selection of the sticker is wrong, it is not approved.',
                causes: [
                    {
                        id: 'UnapprovedCause.B.subtitle.2.cause.1',
                        text: 'If the language selection of the sticker is wrong, it is not approved.',
                    }
                ],
            }
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.C.title',
            text : 'If the commercialization criteria are not met below'
        },
        causes : [
            {
                id: 'UnapprovedCause.C.causes.1',
                text : 'If merchandise is inappropriate in terms of visualization and usability of the content, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.C.causes.2',
                text : 'If any case take in place cause damage to the Sticker Farm brand image, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.C.causes.3',
                text : 'Duplicate content will not be approved.',
            },
            {
                id: 'UnapprovedCause.C.causes.4',
                text : 'If the image does not add value to a conversation, it will not be approved.',
            }
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.D.title',
            text : 'Registers the same content as other platforms'
        },
        causes : [
            {
                id: 'UnapprovedCause.D.causes.1',
                text : 'If you have registered the same content as other platforms, It will not be approved.',
            }
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.E.title',
            text : 'Moral and ethical deficiencies'
        },
        causes : [
            {
                id: 'UnapprovedCause.E.causes.1',
                text : 'If you register content such as crime, sensational expression, abusive language or speech, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.E.causes.2',
                text : 'If you have registered content that may cause social controversy, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.E.causes.3',
                text : 'If you register content that promotes smoking, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.E.causes.4',
                text : 'If you register content that contains anti-social content, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.E.causes.5',
                text : 'If content is registered that may cause discomfort to a particular region, country, religion, culture, group, etc, It will not be approved.',
            }
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.F.title',
            text : 'Copyright, Portrait Rights Violation and Plagiarism'
        },
        causes : [
            {
                id: 'UnapprovedCause.F.causes.1',
                text : 'If you register content that may infringe someone else\'s product or plagiarized copyright or portrait rights, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.F.causes.2',
                text : 'If you register content that could cause any violates your trademark, It will not be approved.',
            }
        ],
        suffixRefer : {
            id: 'UnapprovedCause.F.suffixRefer',
            text:'For more information on copyrights and trademarks, see the Korean Copyright Commission, Patent Office, and Trademark Search Site.'
        }
    },
    {
        title : {
            id: 'UnapprovedCause.G.title',
            text : 'Proposals such as promoting business and advertising'
        },
        prefixRefer : {
            id: 'UnapprovedCause.G.prefixRefer',
            text: 'For business advertising and promotional purposes, please contact mojitok@platfarm.net.'
        },
        causes : [
            {
                id: 'UnapprovedCause.G.causes.1',
                text : 'If you provide content to a third party or register content created for the service or advertising / promotion, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.G.causes.2',
                text : 'If your company has registered content designed for advertising or promotion of your brand or service, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.G.causes.3',
                text : 'If you register content by collaboration between individuals and companies, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.G.causes.4',
                text : 'If you have registered content that contains promotional text, It will not be approved.',
            },
            {
                id: 'UnapprovedCause.G.causes.5',
                text : 'If you have registered content that contains political elements, It will not be approved.',
            }
        ]
    },
    {
        title : {
            id: 'UnapprovedCause.H.title',
            text : 'Pack Guide Not Compliant'
        },
        subtitlePrefix: 'H',
        subtitle : [
            {
                id: 'UnapprovedCause.H.subtitle.1',
                text: 'Pack Thumbnail Guide Not Compliant',
                causes : [
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.1',
                        text : 'If the thumbnail image contains an unrelated background that is not associated with the design concept, the approval will not be granted.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.2',
                        text : 'If the pack thumbnail is not associated with a sticker within the pack, approval will not be granted.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.3',
                        text : 'Copyright, plagiarism, and infringement of portrait rights on pack thumbnails are not authorized.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.4',
                        text : 'If a pack thumbnail is assessed to be less readable on mobile, it will not be approved.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.5',
                        text : 'Pack thumbnails will not be approved if they contain morally and ethically unsuitable content.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.1.causes.6',
                        text: 'Pack thumbnails must be still images(PNG form). If an animated(GIF form) image is uploaded, it will not be approved.',
                    }
                ]
            },
            {
                id: 'UnapprovedCause.H.subtitle.2',
                text: 'Pack Information Guide Not Compliant',
                causes : [
                    {
                        id: 'UnapprovedCause.H.subtitle.2.causes.1',
                        text : 'If the pack title contain words that are morally and ethically unsuitable, approval will not be granted.'
                    },
                    {
                        id: 'UnapprovedCause.H.subtitle.2.causes.2',
                        text : 'If the description contain words that are morally and ethically unsuitable, approval will not be granted.'
                    }
                ]
            },
            {
                id: 'UnapprovedCause.H.subtitle.3',
                text: 'Compliance with pack rules',
                causes : [
                    {
                        id: 'UnapprovedCause.H.subtitle.3.causes.1',
                        text : 'If the minimum requirements are not met or the pack information is inaccurate when creating the pack, it will not be approved.',
                    },
                ],
            },
        ]
    }
]

const RejectedReasons = props => (
    <Layout style={{background: '#fff'}}>
		<GuideNav selectedKey={"rejectedReasons"}/>
		<Content style={{margin: 20}}>
			<Headline id="UnapprovedCause.headline" defaultMessage="Guide to Reject Reasons"/>
			<div style={{marginLeft:17,fontSize:'16px',lineHeight:'24px',letterSpacing:'0.5px',color:'rgba(0, 0, 0, 0.6)'}}>
				<FormattedHTMLMessage
					id="UnapprovedCause.caution"
					defaultMessage="Please check the Rejection Guide carefully before submitting your content.<br/>Deployment may be interrupted if this is the case in the Reject Reasons after approval.<br/>In addition, distribution may be stopped if it does not fall under the Rejection Guide but is<br>deemed inappropriate. If your content includes pictures, you can also be requested a proof<br>of use document for those pictures.<br>(update 2020.11.13.)"
				/>
			</div>
			<ol type="A" style={{fontFamily:'NotoSans-Bold', fontSize:20, marginBottom:100}}>
				{
					causeData.map((data, index) =>
						<li key={index} style={{margin:'80px 0px', color: 'rgba(0, 0, 0, 0.87)', lineHeight:'24px', letterSpacing:'0.15 px'}}>
							<FormattedMessage
								id={data.title.id}
								defaultMessage={data.title.text}
							/>
							<div style={{fontFamily:'NotoSans', fontSize:16, color:'rgba(0, 0, 0, 0.6)', margin:'24px 0px'}}>
								{
									data.prefixRefer ? 
										<FormattedHTMLMessage
											id={data.prefixRefer.id}
											defaultMessage={data.prefixRefer.text}
										/> : null
								}
							</div>
							<ol type="1" className={data.subtitle ? "unapproved-cause-list-wapper subtitle-wapper" : "unapproved-cause-list-wapper"}>
								{
								data.subtitle ?                 
									data.subtitle.map((subData, index) => 
										<li key={index} className={`unapproved-cause-subtitle-list unapproved-cause-subtitle-${data.subtitlePrefix}`}>
											<strong>
												<FormattedMessage
													id={subData.id}
													defaultMessage={subData.text}
												/>
											</strong>
											<ol type="1" className="unapproved-cause-list-wapper">
											{
												subData.causes.map((cause, idx) => 
													<li key={idx} style={{padding:'2px 10px'}}>
														<FormattedHTMLMessage
															id={cause.id}
															defaultMessage={cause.text}
														/>
													</li>
												)
											}
											</ol>
										</li>
									)
									:
									data.causes.map((cause, idx) => 
										<li key={idx} style={{padding:'2px 10px'}}>
											<FormattedHTMLMessage
												id={cause.id}
												defaultMessage={cause.text}
											/>
										</li>
									)     
								}
							</ol>
							<div style={{fontFamily:'NotoSans', fontSize:16, color:'rgba(0, 0, 0, 0.6)', margin:'24px 0px'}}>
								{
									data.suffixRefer ? 
										<FormattedHTMLMessage
											id={data.suffixRefer.id}
											defaultMessage={data.suffixRefer.text}
										/> : null
								}
							</div>
						</li>
					)
				}
			</ol>  
		</Content>
    </Layout>
)

export default RejectedReasons;
